import type {
  FotoDeTiendaModalProps,
  UseFotoDeTiendaModalReturn,
} from "./types";

export const useFotoDeTiendaModal = ({
  setVerFotoDeTienda,
}: FotoDeTiendaModalProps): UseFotoDeTiendaModalReturn => {
  const handleClose = () => {
    setVerFotoDeTienda(false);
  };

  return {
    handleClose,
  };
};
